import { useEffect, useState } from "react";
import camera from "../../assets/icons/cam.svg";
import LocalCarousel from "./LocalCarousel";
import { toast } from "react-toastify";
import {
  getImageDimensions,
  ImageSizeAndDimensionChecker,
  resizeImage,
} from "../../utils/utils";

type ImageUploaderProps = {
  register?: any;
  setValue?: any;
  height?: string;
  fieldName?: string;
  data?: any;
  imageWidth?: string;
  clickHereRef: string;
  errors?: any;
  title?: string;
  imageView?: boolean;
  dimension: any;
};

const MultiImageUploader = ({
  register,
  setValue,
  height,
  fieldName,
  data,
  imageWidth,
  errors,
  clickHereRef,
  title,
  imageView,
  dimension,
}: ImageUploaderProps) => {
  const [preview, setPreview] = useState<any[]>([]);
  let startId = 0;

  useEffect(() => {
    let images = preview?.map((ob) => ob.image);
    setValue(fieldName, images);
  }, [preview, setValue, fieldName]);

  const onChangeHandler = async (e: React.ChangeEvent<HTMLInputElement>) => {
    
    //@ts-ignore
    const files: any = new Array(...e.target.files);
    //@ts-ignore
    files.map(async (file, index) => {
      if (file) {
        try {
          const { width, height } = await getImageDimensions(file);
          if (
            !ImageSizeAndDimensionChecker(
              width,
              height,
              dimension[0],
              dimension[1],
              file.size
            )
          ) {
            e.target.value = "";
            return;
          }
          const reader = new FileReader();
          reader.onloadend = async () => {
            const downSacledImage = await resizeImage(
              reader.result,
              dimension[0],
              dimension[1]
            );
            setPreview((prevPreview) =>
              [
                ...prevPreview,
                { id: startId + index, image: downSacledImage },
              ].sort((a, b) => a.id - b.id)
            );
          };
          reader.readAsDataURL(file); // Read the file as a Data URL
        } catch (error) {
          console.error("Error reading image:", error);
        }
      }
    });
  };

  return (
    <>
      <div
        className={` ${
          preview.length === 0
            ? `border-primary border-dotted border-2 ${
                height ? height : "h-[180px]"
              }  bg-[#F3F3F3]`
            : ""
        } rounded-lg  `}
      >
        {preview.length === 0 ? (
          <label
            className="relative flex flex-col  justify-center items-center   rounded-lg  gap-5 py-10"
            htmlFor={preview.length === 0 ? clickHereRef : ""}
          >
            <img loading="lazy" src={camera} alt="camera" className="w-[43px]" />
            <div className=" text-center  text-sm ">
              <>
                <input
                  type="file"
                  multiple
                  accept={"image/*"}
                  hidden
                  id={clickHereRef}
                  {...register(fieldName, {
                    required: true,
                  })}
                  onChange={(e) => {
                    onChangeHandler(e);
                  }}
                />

                <p className="font-bold text-sm">
                  Click
                  <span
                    // htmlFor={clickHereRef}
                    className="text-red-500 mx-1 cursor-pointer"
                  >
                    HERE
                  </span>
                  to upload {title}
                </p>

                <p className="block text-xs mt-4  ">
                  {dimension[0]} x {dimension[1]} Px, PNG, JPG <br /> Max size
                  5MB
                </p>
              </>
            </div>
          </label>
        ) : (
          <LocalCarousel
            dimension={dimension}
            images={preview}
            setImages={setPreview}
          />
        )}
      </div>

      {/* @ts-ignore */}
      {errors?.[fieldName] && (
        <p className="text-red-500 text-sm mt-4  ">
          {"Please upload at least one image"}
        </p>
      )}
    </>
  );
};

export default MultiImageUploader;
